import React from 'react'

export const EmptyTitle = () => <h1 className="header__ctr header__tit">{}</h1>
